import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import remove from "@beeldit/core/services/remove";
import { UnpayActionContext } from "./UnpayActionContext";
import store from "@beeldit/core/services/store";

function useUnpay(modelConfig: any) {
  const { elementId, setShowModal } = useContext(UnpayActionContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    store("payments/1/unpay", { external_id: elementId })
      .then((response: any) => {
        setShowModal(false);
        onSuccess();
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useUnpay;
